import React from "react";

const AuctionOverview = () => {
  // You may replace these dummy data with the actual data from your context or API
  const externalAuctions = [
    { platform: "Ebay", currentBid: 100, endTime: Date.now() + 86400000 }, // 1 day from now
    { platform: "GoDaddy", currentBid: 150, endTime: Date.now() + 172800000 }, // 2 days from now
    { platform: "Sedo", currentBid: 120, endTime: Date.now() + 259200000 }, // 3 days from now
  ];

  // You may replace this dummy data with the actual data from your context or API
  const internalAuctions = [
    { provider: "Aucdom", currentBid: 200, endTime: Date.now() + 345600000 }, // 4 days from now
    // Add more internal auctions as needed
  ];

  const calculateTimeRemaining = (endTime) => {
    const now = new Date();
    const difference = endTime - now;
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

    return { days, hours, minutes };
  };

  return (
    <div className="mt-8">
      <h2 className="text-2xl font-semibold mb-4">Auction Overview</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* External Auctions */}
        {externalAuctions.map((auction, index) => (
          <AuctionCard key={index} {...auction} />
        ))}

        {/* Internal Auctions */}
        {internalAuctions.map((auction, index) => (
          <AuctionCard calculateTimeRemaining={calculateTimeRemaining} key={index} {...auction} />
        ))}
      </div>
    </div>
  );
};

const AuctionCard = ({ platform, provider, currentBid, endTime }) => {
    const calculateTimeRemaining = (endTime) => {
        const now = new Date();
        const difference = endTime - now;
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    
        return { days, hours, minutes };
      };
    
      
  const timeRemaining = calculateTimeRemaining(endTime);

  return (
    <div className="bg-white p-4 rounded-md shadow-md">
      <h3 className="text-lg font-semibold mb-2">
        {platform || provider} Auction
      </h3>
      <div className="flex justify-between items-center mb-2">
        <span className="text-gray-500">Current Bid:</span>
        <span className="text-blue-500 font-semibold">{currentBid}</span>
      </div>
      <div className="flex justify-between items-center mb-2">
        <span className="text-gray-500">Time Remaining:</span>
        <span className="text-gray-700">
          {timeRemaining.days} days {timeRemaining.hours} hours{" "}
          {timeRemaining.minutes} minutes
        </span>
      </div>
    </div>
  );
};

export default AuctionOverview;
